import Styles from './AboutPhone.module.scss';
import classnames from "classnames";

//Icons
import SamsungPhoneBody from "../../../../icons/samsung_phone.webp";
import { ReactComponent as DropdownIcon } from "../../../../icons/extra_icons/left.svg"
import { useState } from 'react';

const AboutPhone = () => {

    const [isVisible,setIsVisible] = useState(false)

    const deviceInfo = [
        {
            key: "Phone number",
            value: "+917018700745"
        },
        {
            key: "Product name",
            value: "Galaxy S22"
        },
        {
            key: "Model name",
            value: "SM-S901E/DS"
        },
        {
            key: "Serial number",
            value: "RT67TQU7TYE",
            isBlurred: true
        },
        {
            key: "IMEI (Slot 1)",
            value: "98793798*********",
            isBlurred: true
        },
        {
            key: "IMEI (Slot 2)",
            value: "34223390*********",
            isBlurred: true
        },
    ]


    const developmentInfo = [
        {
            key: "Made with",
            value: "ReactJS"
        },
        {
            key: "Developer",
            value: "Priyansh Datyal"
        },
        {
            key: "Owner",
            value: "Priyansh Datyal"
        },
        {
            key: "Version",
            value: "2.3.1"
        },
        {
            key: "Last version",
            value: "2.2.3"
        },
    ]

    return (
        <div className={Styles.container}>
            <div className={Styles.top_half}>
                <div className={Styles.device}>
                    <div className={Styles.wallpaper} />
                    <img src={SamsungPhoneBody} className={Styles.device_body} />
                    <div className={Styles.device_name}>
                        Priyansh's S22
                    </div>
                </div>
                <div className={Styles.device_info}>
                    {
                        deviceInfo.map((information: any) => {
                            return (
                                <div className={Styles.info} key={information.key}>
                                    <div className={Styles.key}>
                                        {information.key}
                                    </div>
                                    <div className={Styles.value}>
                                        {information.value}
                                        {information.isBlurred && <div className={Styles.blurred} />}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={classnames(Styles.option, "solid_bg")}>
                <div className={classnames(Styles.button, isVisible && Styles.divider)} onClick={()=>{setIsVisible(!isVisible)}} > 
                    <div className={Styles.label}>
                    Software Information
                    </div>
                    <div className={Styles.icon}>
                        <DropdownIcon />
                    </div>
                </div>
                
                {
                   isVisible  && <div className={classnames(Styles.device_info,Styles.special_text)}>
                     {
                         developmentInfo.map((information: any) => {
                             return (
                                 <div className={Styles.info} key={information.key}>
                                     <div className={Styles.key}>
                                         {information.key}
                                     </div>
                                     <div className={Styles.value}>
                                         {information.value}
                                         {information.isBlurred && <div className={Styles.blurred} />}
                                     </div>
                                 </div>
                             )
                         })
                     }
                 </div>
                }
            </div>
        </div>
    )
}

export default AboutPhone
